import { configureStore } from '@reduxjs/toolkit';
import {
    authReducer,
    dashboardReducer,
    adminReducer,
    tournamentReducer,
    coachReducer,
    courtReducer,
    userReducer,
    sportReducer,
    paymentReducer,
    refereeReducer,
} from './slices';

export const store = configureStore({
    reducer: {
        auth: authReducer,
        dashboard: dashboardReducer,
        admin: adminReducer,
        tournament: tournamentReducer,
        coach: coachReducer,
        court: courtReducer,
        user: userReducer,
        sport: sportReducer,
        payment: paymentReducer,
        referee: refereeReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
    devTools: process.env.NODE_ENV !== 'production',
});

export default store;
